import ReactDOM from "react-dom/client";
import React, { Suspense } from "react";
import App from "./App";
import ChunkReloadBoundary from "./components/application/ChunkReloadBoundary";
import { Loading } from "./components";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <ChunkReloadBoundary>
    <Suspense fallback={<Loading />}>
      <App />
    </Suspense>
  </ChunkReloadBoundary>
);
